import Vue from 'vue';

export default class BundleValidator {
  static valid (bundle, enterpriseDeveloper) {
    if (bundle) {
      if (Vue.prototype.$permissions['enterprise-developer']) {
        return BundleValidator.detailsValidity(bundle);
      } else {
        return (
          BundleValidator.detailsValidity(bundle) &&
          BundleValidator.contentsValidity(bundle) &&
          BundleValidator.availabilityValidity(bundle)
        );
      }
    }
  }

  static detailsValidity (bundle) {
    const {
      title,
      description,
      systemRequirements,
    } = bundle;
    return Boolean(
      title &&
      description &&
      systemRequirements, // &&
      // (imageUrl || _imageBlob),
    );
  }

  static contentsValidity (bundle) {
    if (this.detailsValidity(bundle)) {
      return bundle.bundleContents.length > 1 && bundle.bundleContents.some(x => x.discountPercentage > 0);
    }
    return false;
  }

  static availabilityValidity (bundle) {
    if (this.detailsValidity(bundle) && this.contentsValidity(bundle)) {
      return true;
    }
    return false;
  }
}
